import { Component, OnInit, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { ServiceAreasService } from '../../../../services/core/service-areas-service/service-areas.service';
import { sweetAlert } from 'src/app/utils/swal';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
@UntilDestroy()

@Component({
  selector: 'app-service-areas-listing',
  templateUrl: './service-areas-listing.component.html',
  styleUrls: ['./service-areas-listing.component.css']
})
export class ServiceAreasListingComponent implements OnInit {
  serviceAreas: any;
  filteredServiceAreas: any = [];
  selectedStatus = '';
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  search:any;
  status = true;
  numberOfRecords = NUMBER_OF_RECORDS;
  userPermission=UserPermission
  serviceAreaModalObj: any;

  constructor(
    private serviceArea: ServiceAreasService,public permissionService: PermissionService
  ) { }
  ngOnInit() {
    this.getServiceAreas(this.currentPage)
  }

  getServiceAreas(page: number) {
    const queryparams = {
      limit: 50,
      page,
      isActive: this.status
    }
    this.serviceArea.get(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results ) {
          this.serviceAreas = data.results;
          this.serviceAreas = data.results.sort((a: any, b: any) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          );
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      })
  }

  onSelectStatus(evt:any) {
    this.status = evt.target.value === 'true';
    this.getServiceAreas(this.currentPage = 1);
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getServiceAreas(page);
  }


  openServiceAreaModal(serviceArea: any) {
    this.serviceAreaModalObj = serviceArea;
  }

  onSaveServiceArea(evt: any) {
    if (evt) {
      const idx = this.serviceAreas.findIndex((fs: any) => fs.id === evt.id);
      if (this.status === evt.isActive) {
        this.serviceAreas[idx] = evt;
      } else {
        this.serviceAreas.splice(idx, 1);
      }
    }
    this.serviceAreaModalObj = null;
  }

  onCloseServiceAreaModal() {
    this.serviceAreaModalObj = null;
  }


}
